var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9166 3.7256C14.1292 4.022 15.5833 5.42816 15.5833 7.79159C15.5833 8.98936 15.2098 9.94127 14.5534 10.6275C15.7667 11.2769 16.4999 12.4945 16.4999 14.2083C16.4999 16.8687 14.733 18.3333 12.1458 18.3333H11.9166V20.1666H10.0833V18.3333H8.24992V20.1666H6.41659V18.3333H4.58325V16.4999H6.41659V5.49992H4.58325V3.66659H6.41659V1.83325H8.24992V3.66659H10.0833V1.83325H11.9166V3.7256V3.7256ZM10.9999 5.49992H8.24992V10.0833H10.9999C12.7931 10.0833 13.7499 9.33971 13.7499 7.79159C13.7499 6.24347 12.7931 5.49992 10.9999 5.49992ZM8.24992 11.9166V16.4999H12.1458C13.7886 16.4999 14.6666 15.7721 14.6666 14.2083C14.6666 12.6444 13.7886 11.9166 12.1458 11.9166H8.24992Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.48e4775cedba6aa31127b81274b76e33.svg";
export { ForwardRef as ReactComponent };